import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

const ranges: Record<string, Record<string, string>> = {
  settledInstitutions: {
    '0': '0',
    '1': '0-5',
    '2': '5-9',
    '3': '9-14',
    '4': '14-17',
    '5': '17+',
  },
  creditDuration: {
    '0': '0',
    '1': '0-220',
    '2': '220-450',
    '3': '450-520',
    '4': '520+',
  },
  lastTransaction: {
    '0': '0',
    '1': '0-5',
    '2': '5-25',
    '3': '25+',
  },
  totalAmount: {
    '0': '0',
    '1': '0-45000',
    '2': '45000-115000',
    '3': '115000+',
  },
  failedAmount: {
    '0': '0',
    '1': '0-600',
    '2': '600-1300',
    '3': '1300+',
  },
  successCount: {
    '0': '0',
    '1': '0-2',
    '2': '2-10',
    '3': '10-34',
    '4': '34-60',
    '5': '60+',
  },
  failedCount: {
    '0': '0',
    '1': '0-3',
    '2': '3-5',
    '3': '5-10',
    '4': '10+',
  },
}

const decode = (value: string, type: keyof typeof ranges) => ranges[type][value] ?? '—'

const Field = ({ label, value }: { label: string; value?: string }) => (
  <div className="flex flex-col gap-1">
    <Text size="xs" c="dimmed">
      {label}
    </Text>
    <Text size="sm" className="text-gray-700" fw={500}>
      {value || '—'}
    </Text>
  </div>
)

export default function LoanPortfolio({ data }: { data: any }) {
  const theme = useTheme()

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        贷款资产情况
      </Text>
      <Stack gap="sm" className="mt-3">
        <div className="grid gap-3 md:grid-cols-2">
          <Field label="已结清机构数" value={decode(data?.loan_info_xyp_cpl0002, 'settledInstitutions')} />
          <Field label="信用贷款时长(天)" value={decode(data?.loan_info_xyp_cpl0045, 'creditDuration')} />
          <Field label="最近一次交易距今(天)" value={decode(data?.loan_info_xyp_cpl0046, 'lastTransaction')} />
          <Field label="累计交易金额(元)" value={decode(data?.loan_info_xyp_t01aczzzz, 'totalAmount')} />
          <Field label="能力不足导致失败金额(元)" value={decode(data?.loan_info_xyp_t01abzzza, 'failedAmount')} />
          <Field label="成功还款笔数" value={decode(data?.loan_info_xyp_cpl0014, 'successCount')} />
          <Field label="交易失败笔数" value={decode(data?.loan_info_xyp_cpl0015, 'failedCount')} />
        </div>
      </Stack>
    </div>
  )
}
